// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"H_PH_TheComp__v5Vb7"};